export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return parts
    .pop()
    .split(";")
    .shift();
}

export function debounce(fn, ms) {
  let timeout = null;
  return function(...args) {
    if (timeout) {
      clearTimeout(timeout)
    }
    timeout = setTimeout(_ => fn(...args), ms)
  }
}
